module.exports = __webpack_public_path__ + "img/home_menu_10_default.6fa09d05.png";